import React from "react";
import AppTemplate from "../components/PlanSelectTop";

const PlanSelectTop: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default PlanSelectTop;
